import { gql } from "@apollo/client";
import {
  PaginatedListMetaNoNestingFragment,
  ProductKitItemNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import { ProductKitItem as ProductKitItemEntity } from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import ProductKitItemModel from "../../data/model/ProductKitItem";
import { listOptions, listVariables } from "../constants";
import { EntityResourceDefinition } from "../entity-resource-definition";
import { PageQueryOptions, pageQuery } from "../page-query";

const productKitItemsQuery = gql`
${PaginatedListMetaNoNestingFragment}
${ProductKitItemNoNestingFragment}
query GetProductKitItems(${listVariables}) {
    productKitItems(${listOptions}) {
        items {
           ...ProductKitItemNoNesting
        }
        meta {
          ...PaginatedListMetaNoNesting
        }
    }
}
`;

export const productKitItemDefinition = new EntityResourceDefinition<
  ProductKitItemEntity,
  ProductKitItemModel
>({
  entity: "product_kit_items",
  query: productKitItemsQuery,
  prepareEntity: (newEntity, fetchedEntity) => {
    newEntity.product.id = fetchedEntity.productId;
    newEntity.productKit.id = fetchedEntity.productKitId;
    newEntity.quantity = fetchedEntity.quantity;
    newEntity.price = fetchedEntity.price;
  },
  fetchEntities: (options?: PageQueryOptions) => {
    return pageQuery(client, "productKitItems", productKitItemsQuery, options);
  },
});
